import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { EncryptedInstructionDocumentTypeRequest } from '../../Models/Models/Documents/InstructionDocuments/EncryptedInstructionDocumentTypeRequest';
import { QuoteModel } from '../../Models/Models/Processes/Quote/QuoteModel';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionDocumentTypeQuoteModelRequestTriggerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(quoteModel: QuoteModel): Promise<Array<EncryptedInstructionDocumentTypeRequest>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/InstructionDocumentTypeQuoteModelRequestTrigger/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { quoteModel: quoteModel }

    return AjaxWrapper.post<Array<EncryptedInstructionDocumentTypeRequest>, any>(url, data);
  }
}

